const FILE_EXT_ICON_PATH = '/assets/img/icons/file-ext';

export const FILE_ICONS = {
  audio: `${FILE_EXT_ICON_PATH}/file-audio.svg`,
  pdf: `${FILE_EXT_ICON_PATH}/file-pdf.svg`,
  ppt: `${FILE_EXT_ICON_PATH}/file-slider.svg`,
  doc: `${FILE_EXT_ICON_PATH}/file-text.svg`,
  xls: `${FILE_EXT_ICON_PATH}/file-csv.svg`,
  img: `${FILE_EXT_ICON_PATH}/file-img.svg`,
  text: `${FILE_EXT_ICON_PATH}/file-text.svg`,
  csv: `${FILE_EXT_ICON_PATH}/file-csv.svg`,
  slider: `${FILE_EXT_ICON_PATH}/file-slider.svg`,
  obj: `${FILE_EXT_ICON_PATH}/file-3d.svg`,
  default: `${FILE_EXT_ICON_PATH}/file-default.svg`,
} as const;
